import NavBar from "../components/navbar/navBar";
import Footer from "../components/footer";
import AllProjectsFetcher from "../components/fetchers/allprojectsFetcher";
import { Typography, Box } from "@mui/material";
import { useContext } from "react";
import { themeContext } from "../context";

const ProjectPage = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <>
      <NavBar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 4,
          mb: 4,
          flexDirection: "column",
          alignItems: "center", // Ensure alignment is applied consistently
          textAlign: "center",  // Center text within the Box
        }}
      >
        <Typography
          sx={{
            color: darkMode ? "white" : "var(--black)",
            fontSize: "2.5rem",
            fontWeight: "bold",
          }}
        >
          Recent Developed
        </Typography>
        <Typography
          sx={{
            color: "var(--orange)",
            fontSize: "3rem",
            fontWeight: "bold",
          }}
        >
          Projects
        </Typography>
      </Box>
      <AllProjectsFetcher />
      <Footer />
    </>
  );
};

export default ProjectPage;